export const siteInfo = {
  name: "哈哈影院",
  tagline: "高清免费在线观看",
  description: "哈哈影院提供高清免费在线观看服务，涵盖电影、电视剧等海量影视大全，播放不缓冲，流畅追剧体验，满足您所有在线观影需求。",
  url: "https://hahacinema.com/",
  email: "support@hahacinema.com",
  address: "北京市朝阳区望京SOHO T1",
  phone: "400-888-8888",
  foundedYear: 2020,
  stats: {
    totalMovies: 52860,
    totalSeries: 32150,
    dailyUsers: 8900000,
    positiveRating: 98.7,
  },
};